import $ from 'jquery';
//import { size } from 'lodash';
import env from './env';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
//import moment from 'moment';

Swiper.use([Navigation, Pagination, Autoplay]);
// ---------------------------------------------------------
// Custom Functions for Back-End
// ---------------------------------------------------------
function initCarouselDepartment() {
  var carouselDepartmentEl = document.getElementById('jsCarouselDepartment');
  if (carouselDepartmentEl != null) {
    var carouselDepartment = new Swiper('#jsCarouselDepartment .swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 18,
      speed: 750,
      breakpoints: {
        320: {
          spaceBetween: 18,
        },
        1199: {
          spaceBetween: 18,
        },
        1600: {
          spaceBetween: 18 * window.innerWidth / 1200,
        }
      },
      navigation: {
        nextEl: '#jsCarouselDepartment .jsNext',
        prevEl: '#jsCarouselDepartment .jsPrev',
        clickable: true
      },
      autoplay: false,
      on: {
        init: function() {
          carouselDepartmentEl.classList.add('active');
        },
      },
    });
    return carouselDepartment;
  } else {
    return null;
  }
}

window.addEventListener('load', function(e) {
  /////////////////////////////////////////////////////////////////
  //  Events
  /////////////////////////////////////////////////////////////////
  function getAjaxHeaders() {
    return {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content'),
    };
  }

  $(document).on('click', '.btnSubscribeEvent', subscribeEvent);

  var carouselEl = initCarouselDepartment();

  function clickCategorySlide() {
    var id = this.dataset.id;
    const stripTrailingSlashUrl = (path, id) => {
      return path.endsWith('/') ?
        path.slice(0, -1) + '/' + id :
        path + '/' + id;
    };
    $.ajax({
      headers: getAjaxHeaders(),
      type: 'GET',
      url: stripTrailingSlashUrl(env('AJAX_SLIDE_URL'), id),
      cache: false,
      contentType: false,
      processData: false,
      success: (response) => {
        if (response.success) {
          carouselEl.removeAllSlides();
          var items = response.html.split('</div>');
          for (var i = 0; i < items.length; i++) {
            carouselEl.appendSlide(items[i] + '</div>');
          }
        }
      },
      error: function(response) {
        carouselEl.removeAllSlides();
      }
    });
  }

  $('.jsDepartmentTab').on('click', clickCategorySlide);

  $('.onlyHaftSize').on('input', function() {
    var halfVal = $(this).val().replace(/[！-～]/g,
      function(tmpStr) {
        return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
      }
    );
    $(this).val(halfVal.replace(/[^0-9]/g, ''));
  });

  function subscribeEvent() {
    let category = $('input[name="category"]').val();
    let refererLink = $('input[name="referer_link"').val();
    let opencampusId = $('input[name="opencampus_id"').val();
    let datesIds = $('input[name=' + $.escapeSelector('dates[]') + ']:checked').map(function() {
      return $(this).val();
    }).get();

    if (datesIds.length == 0) {
      datesIds = ($('select[name=' + $.escapeSelector('dates[]') + ']').map(function() {
        return $(this).val();
      }).get());
    }
    if (datesIds.length == 0) {
      datesIds = ($('input:hidden[name=' + $.escapeSelector('dates[]') + ']').map(function() {
        return $(this).val();
      }).get());
    }

    $.ajax({
      headers: getAjaxHeaders(),
      url: env('SUBSCRIBE_EVENT_URL'),
      type: 'POST',
      dataType: 'JSON',
      data: {
        category: category,
        referer_link: refererLink,
        opencampus_id: opencampusId,
        dates: datesIds
      },
      beforeSend: function(request) {
        request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      },
      success: function(response) {
        if (response.status == true) {
          window.location.href = response.url;
        } else {
          $('div#blockSchedule').find('p.textAlert').remove();
          if ($('div#calendar').length == 1) {
            if ($('li.cld-day.selected').length == 0) {
              $('div#blockSchedule').append('<p class="textAlert">※日程を選択してください</p>');
            } else if ($('div.timeZone') != 'undefined') {
              $('div#blockSchedule').append('<p class="textAlert">※時間帯を選択してください</p>');
            }
          } else {
            $('div#blockSchedule').append('<p class="textAlert">※日程を選択してください</p>');
          }
        }
      }
    });
  }
});
